import { FiAperture, FiBookmark, FiBox, FiCheckCircle, FiCoffee, FiDribbble, FiFacebook, FiInstagram, FiLinkedin, FiMessageCircle, FiSend, FiStar, FiTwitter, FiUser, FiUserCheck } from "react-icons/fi";

import team1 from '../assets/images/team/1.jpg'
import team2 from '../assets/images/team/2.jpg'
import team3 from '../assets/images/team/3.jpg'
import team4 from '../assets/images/team/4.jpg'
import team5 from '../assets/images/team/5.jpg'
import team6 from '../assets/images/team/6.jpg'
import team7 from '../assets/images/team/7.jpg'
import team8 from '../assets/images/team/8.jpg'

import blog1 from '../assets/images/blog/1.jpg'
import blog2 from '../assets/images/blog/2.jpg'
import blog3 from '../assets/images/blog/3.jpg'
import blog4 from '../assets/images/blog/4.jpg'
import blog5 from '../assets/images/blog/5.jpg'
import blog6 from '../assets/images/blog/6.jpg'
import blog7 from '../assets/images/blog/7.jpg'
import blog8 from '../assets/images/blog/8.jpg'
import blog9 from '../assets/images/blog/9.jpg'

import coin1 from '../assets/images/coin/Bitcoin-BTC.png'
import coin2 from '../assets/images/coin/Ethereum-ETH.png'
import coin3 from '../assets/images/coin/Avalanche-AVAX.png'
import coin4 from '../assets/images/coin/BNB-BNB.png'
import coin5 from '../assets/images/coin/Cardano-ADA.png'
import coin6 from '../assets/images/coin/Dai-DAI.png'
import coin7 from '../assets/images/coin/Polkadot-DOT.png'
import coin8 from '../assets/images/coin/Shiba-Inu-SHIB.png'


import fea1 from '../assets/images/cpu.svg'
import fea2 from '../assets/images/analytics.svg'
import fea3 from '../assets/images/exchange.svg'
import fea4 from '../assets/images/money.svg'

export const featureData = [
    {
        image:fea1,
        title:'Buy & Sell Crypto',
        desc:"Buy or sell Bitcoin, Ethereum, and other crypto assets with your credit card, debit card, or bank account."
    },
    {
        image:fea2,
        title:'Trade Assets',
        desc:"Discover new and innovative crypto assets with over 200 spot trading pairs and 25 margin trading pairs."
    },
    {
        image:fea3,
        title:'Hedge with Supercoin Futures',
        desc:"Trade Bitcoin, Ethereum, and other perpetual with up to 100x leverage on Supercoin Futures."
    },
    {
        image:fea4,
        title:'Earn Rewards for Trading',
        desc:"Never miss an opportunity for a little competition. Join our latest campaigns to earn rewards."
    },
    
]

export const clientData = [
    {
        image:team1,
        name:'Calvin Carlo',
        position:'Manager',
        desc:"According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero Launch your campaign and benefit from our expertise",
        tag:'Creativity',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team2,
        name:'Carl Oliver',
        position:'Manager',
        desc:"I didn't know a thing about icon design until I read this book. Now I can create any icon I need in no time. Great resource!",
        tag:'Modern',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team3,
        name:'Barbara McIntosh',
        position:'Manager',
        desc:"The best part about Flipup is every time I pay my employees, my bank balance doesn't go down like it used to. Looking forward to spending this extra cash when I figure out why my card is being declined.",
        tag:'Social Marketing',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team4,
        name:'Janisha Doll',
        position:'Manager',
        desc:"I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though",
        tag:'Digital Marketing',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team5,
        name:'Esther Howard',
        position:'Manager',
        desc:"There are so many things I had to do with my old software that I just don't do at all with Flipup. Suspicious but I can't say I don't love it",
        tag:'SEO',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team6,
        name:'Joshua William',
        position:'Manager',
        desc:"I'm trying to get a hold of someone in support, I'm in a lot of trouble right now and they are saying it has something to do with my books. Please get back to me right away.",
        tag:'Classic',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team7,
        name:'Thomas Israel',
        position:'Manager',
        desc:"This is the fourth email I've sent to your support team. I am literally being held in jail for tax fraud. Please answer your damn emails, this is important. ",
        tag:'Features',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team8,
        name:'Jill Webb',
        position:'Manager',
        desc:"I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though. ",
        tag:'Branding',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team2,
        name:'Jennifer White',
        position:'Manager',
        desc:"The team is exceptional. Their passion for what they do is evident in the results they deliver. We're grateful to have them as a trusted partner in our journey. ",
        tag:'Product Design',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        tag:'Supercoin',
        title:'Utilizing mobile technology in the field',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'13th Sept 2024'
    },
    {
        id:2,
        image:blog2,
        tag:'Supercoin',
        title:'Success Story: Businessman in Harlem',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'29th Nov 2024'
    },
    {
        id:3,
        image:blog3,
        tag:'Supercoin',
        title:'How Does Marketing Automation Help Lead',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'29th Desc 2024'
    },
    {
        id:4,
        image:blog4,
        tag:'Supercoin',
        title:"Working from home? Let's get started.",
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'13th March 2024'
    },
    {
        id:5,
        image:blog5,
        tag:'Supercoin',
        title:'The Ultimate Success Formula - How?',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'5th May 2024'
    },
    {
        id:6,
        image:blog6,
        tag:'Supercoin',
        title:'The Major Differences Between SEO & Local SEO',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'19th June 2024'
    },
    {
        id:7,
        image:blog7,
        tag:'Supercoin',
        title:'Building intelligent transportation systems',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'20th June 2024'
    },
    {
        id:8,
        image:blog8,
        tag:'Supercoin',
        title:'12 Questions to Ask Before Hiring a SEO Agency',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'31st Aug 2024'
    },
    {
        id:9,
        image:blog9,
        tag:'Supercoin',
        title:'How a Social Media Audit Can Help You',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'1st Sept 2024'
    },
]

export const footerSocial = [
    {
        icon:FiDribbble,
        link:'https://dribbble.com/shreethemes'
    },
    {
        icon:FiLinkedin,
        link:'http://linkedin.com/company/shreethemes'
    },
    {
        icon:FiFacebook,
        link:'https://www.facebook.com/shreethemes'
    },
    {
        icon:FiInstagram,
        link:'https://www.instagram.com/shreethemes'
    },
    {
        icon:FiTwitter,
        link:'https://twitter.com/shreethemes'
    },
]

export const footerCompany = [
    {
        title:'About us',
        link:'/aboutus'
    },
    {
        title:'Services',
        link:'/services'
    },
    {
        title:'Team',
        link:'/team'
    },
    {
        title:'Pricing',
        link:'/pricing'
    },
    {
        title:'Blog',
        link:'/blogs'
    },
    {
        title:'Login',
        link:'/login'
    },
]

export const footerLink = [
    {
        title:'Helpcenter',
        link:'/faqs'
    },
    {
        title:'Terms of Services',
        link:'/terms'
    },
    {
        title:'Privacy Policy',
        link:'/privacy'
    },
]

export const footerLink2 = [
    'Privacy','Terms','FAQs','Contact'
]

export const counterData = [
    {
        icon:FiCheckCircle,
        title:'Project Completed',
        value:'49'
    },
    {
        icon:FiCoffee,
        title:'Cup of Coffee',
        value:'2461'
    },
    {
        icon:FiUserCheck,
        title:'Client Satisfaction',
        value:'99'
    },
    {
        icon:FiBox,
        title:'Country Offices',
        value:'49'
    },
]

export const teamData = [
    {
        image:team1,
        name:'Jack John',
        position:'Founder & CEO',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team2,
        name:'Jeremiah Green',
        position:'CTO',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team3,
        name:'Christin Vasquez',
        position:'Developer',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team4,
        name:'Lillian Boldt',
        position:'Product Manager',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team5,
        name:'Krista John',
        position:'Creative Director',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team6,
        name:'Ricky Peters',
        position:'Market Researcher',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team7,
        name:'Roger Jackson',
        position:'Marketing Expert',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team8,
        name:'Camille Smith',
        position:'Director of HR',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
]

export const servicesData = [
    {
        icon:FiAperture,
        title:'Platform Fees',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon:FiSend,
        title:'Service Level',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon:FiUser,
        title:'Take profit / Stoploss',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon:FiStar,
        title:'Trailing Stop',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon:FiBookmark,
        title:'Pending Orders',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon:FiMessageCircle,
        title:'24/7 Support',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
]

export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use Supercoin ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]

export const recentPost = [
    {
        image:blog1,
        title:'Consultant Business',
        date:'13th March 2024'
    },
    {
        image:blog2,
        title:'Grow Your Business',
        date:'5th May 2024'
    },
    {
        image:blog3,
        title:'Look On The Glorious Balance',
        date:'19th June 2024'
    },
]

export const tagCloud =[
    'Business','Finance','Marketing','Fashion','Bride','Lifestyle','Travel','Beauty','Video','Audio',
]

export const tearmsData = [ 
    'Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand','Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand'
]

export const marketData = [
    {
        image:coin1,
        name:'Bitcoin',
        symbol:'BTC',
        price:'$34587',
        perChange:'-2.5%',
        change:'-$745',
        marketCap:'$725,354M',
        status:'loss'
    },
    {
        image:coin2,
        name:'Ethereum',
        symbol:'ETH',
        price:'$216',
        perChange:'+.264%',
        change:'+$.264',
        marketCap:'$11,100M',
        status:'profit'
    },
    {
        image:coin3,
        name:'Avalanche',
        symbol:'AVAX',
        price:'$452',
        perChange:'-1.9%',
        change:'-$1.9',
        marketCap:'$45,785M',
        status:'loss'
    },
    {
        image:coin4,
        name:'BNB',
        symbol:'BNB',
        price:'$154',
        perChange:'+1.05%',
        change:'+$1.05',
        marketCap:'$85,478M',
        status:'profit'
    },
    {
        image:coin5,
        name:'Cardano',
        symbol:'ADA',
        price:'$854',
        perChange:'+1.705%',
        change:'+$1.705',
        marketCap:'$112,452M',
        status:'profit'
    },
    {
        image:coin6,
        name:' Dai',
        symbol:'DAI',
        price:'$548',
        perChange:'-3.2%',
        change:'-$3.2',
        marketCap:'$4,712M',
        status:'loss'
    },
    {
        image:coin7,
        name:'Polkadot',
        symbol:'DOT',
        price:'$965',
        perChange:'+1.465%',
        change:'+$1.465',
        marketCap:'$487,552M',
        status:'profit'
    },
    {
        image:coin8,
        name:' Shiba Inu',
        symbol:'SHIB',
        price:'$4875',
        perChange:'-1.08%',
        change:'-$1.08',
        marketCap:'$55,221M',
        status:'loss'
    },
]